export default "__VITE_ASSET__9r2pYWPd__"